module.exports = __webpack_public_path__ + "static/media/mr-burns.a60c0247.png";